// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ox-0";
export var discountCodeInput = "_ox-1";